import { render, staticRenderFns } from "./auctionDetail.vue?vue&type=template&id=ce304c80&scoped=true&"
import script from "./auctionDetail.vue?vue&type=script&lang=js&"
export * from "./auctionDetail.vue?vue&type=script&lang=js&"
import style0 from "./auctionDetail.vue?vue&type=style&index=0&id=ce304c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce304c80",
  null
  
)

export default component.exports